import React from 'react';
import ReactDOM from 'react-dom/client'; 
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Clarity from '@microsoft/clarity'; 

if (process.env.REACT_APP_ENV === 'prod') {
  Clarity.init("w0qfi8ltsn");
}
const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Root element with id 'root' not found");
}

const root = ReactDOM.createRoot(rootElement);

root.render(
  <React.StrictMode>
  
    <App />
    
  </React.StrictMode>
);

reportWebVitals(console.log);